import ProgettoCuoreListPage from "./pages/ProgettoCuoreListPage.vue";

export default {
    ProgettoCuoreListPage,
};
